import React,{useEffect,useRef,useState} from 'react'
import WebTemplate from '../Components/WebTemplate'
import { useGetAllSchoolsQuery} from '../Services/modules/school';
import { Link,useSearchParams  } from 'react-router-dom';
import sainikshala from "../assets/img/sainikshala.jpeg";
import { Config } from '../Config';

function TseGeneralMeritList() {
 
      
        return(
            <>
          

              <main id="main">
              <section id="clients" class="clients section-bg">
      <div class="container">

        <div class="row" data-aos="zoom-in">
    

        <table className="table">
      <thead>
        <tr>
        <th style={{textAlign:'center'}}>Index</th>
         
          <th style={{textAlign:'center'}}> गुणवत्ता शोध परीक्षा १ली याद्या खालील प्रमाणे  2025-26</th>
         
        </tr>
      </thead>
      <tbody>
    
          <tr>
            <td>1</td>
            <td>           
            <a href={`${Config.API_URL_FILE}/GeneralMeritList/tse/1_TSE Rural Prize Holders List.pdf`} 
            style={{color:'blue'}}

            target='_blank'>

             
            सर्वसाधारण गुणवत्ता यादी १ली ग्रामीण (2025-26 )
              </a>
              </td>           
          </tr>
      <tr>
            <td>2</td>
            <td>           
            <a href={`${Config.API_URL_FILE}/GeneralMeritList/tse/1_TSE Urban Prize Holders List.pdf`} 
            style={{color:'blue'}}
            target='_blank'>
     सर्वसाधारण गुणवत्ता यादी १ली शहरी (2025-26)
              </a>
           
              </td>           
          </tr>
          <tr>
            <td>3</td>
            <td>           
            <a href={`${Config.API_URL_FILE}/GeneralMeritList/tse/1_TSE State Prize Holders List.pdf`}
            style={{color:'blue'}}
             target='_blank'>

               
        राज्यस्तरीय प्रथम ३ क्रमांक विद्यार्थी १ली (2025-26)
              </a>
           
              </td>           
          </tr>
        
      </tbody>
    </table>

    <table className="table">
      <thead>
        <tr>
        <th style={{textAlign:'center'}}>Index</th>
         
          <th style={{textAlign:'center'}}> गुणवत्ता शोध परीक्षा २री याद्या खालील प्रमाणे  2025-26</th>
         
        </tr>
      </thead>
      <tbody>
    
          <tr>
            <td>1</td>
            <td>           
            <a href={`${Config.API_URL_FILE}/GeneralMeritList/tse/2_TSE Rural Prize Holders List.pdf`} 
            style={{color:'blue'}}

            target='_blank'>

             
            सर्वसाधारण गुणवत्ता यादी २री ग्रामीण (2025-26 )
              </a>
              </td>           
          </tr>
      <tr>
            <td>2</td>
            <td>           
            <a href={`${Config.API_URL_FILE}/GeneralMeritList/tse/2_TSE Urban Prize Holders List.pdf`} 
            style={{color:'blue'}}
            target='_blank'>
      सर्वसाधारण गुणवत्ता यादी २री शहरी (2025-26)
              </a>
           
              </td>           
          </tr>
          <tr>
            <td>3</td>
            <td>           
            <a href={`${Config.API_URL_FILE}/GeneralMeritList/tse/2_TSE State Prize Holders List.pdf`} 
            style={{color:'blue'}}

            target='_blank'>

      राज्यस्तरीय प्रथम ३ क्रमांक विद्यार्थी २री (2025-26)
              </a>
           
              </td>           
          </tr>
        
      </tbody>
    </table>
    <table className="table">
      <thead>
        <tr>
        <th style={{textAlign:'center'}}>Index</th>
         
          <th style={{textAlign:'center'}}> गुणवत्ता शोध परीक्षा ३री याद्या खालील प्रमाणे  2025-26</th>
         
        </tr>
      </thead>
      <tbody>
    
          <tr>
            <td>1</td>
            <td>           
            <a href={`${Config.API_URL_FILE}/GeneralMeritList/tse/3_TSE Rural Prize Holders List.pdf`} 
            style={{color:'blue'}}

            target='_blank'>

             
            सर्वसाधारण गुणवत्ता यादी ३री ग्रामीण (2025-26 )
              </a>
              </td>           
          </tr>
      <tr>
            <td>2</td>
            <td>           
            <a href={`${Config.API_URL_FILE}/GeneralMeritList/tse/3_TSE Urban Prize Holders List.pdf`} 
            style={{color:'blue'}}
            target='_blank'>
      सर्वसाधारण गुणवत्ता यादी ३री शहरी (2025-26)
              </a>
           
              </td>           
          </tr>
          <tr>
            <td>3</td>
            <td>           
            <a href={`${Config.API_URL_FILE}/GeneralMeritList/tse/3_TSE State Prize Holders List.pdf`} 
            style={{color:'blue'}}

            target='_blank'>

      राज्यस्तरीय प्रथम ३ क्रमांक विद्यार्थी ३री (2025-26)
              </a>
           
              </td>           
          </tr>
        
      </tbody>
    </table>

    <table className="table">
      <thead>
        <tr>
        <th style={{textAlign:'center'}}>Index</th>
         
          <th style={{textAlign:'center'}}> गुणवत्ता शोध परीक्षा ६वी याद्या खालील प्रमाणे 2025-26</th>
         
        </tr>
      </thead>
      <tbody>
    
          <tr>
            <td>1</td>
            <td>           
            <a href={`${Config.API_URL_FILE}/GeneralMeritList/tse/6_TSE Rural Prize Holders List.pdf`}
            style={{color:'blue'}}
             target='_blank'>

             
            सर्वसाधारण गुणवत्ता यादी ६वी ग्रामीण (2025-26 )
              </a>
              </td>           
          </tr>
      <tr>
            <td>2</td>
            <td>           
            <a href={`${Config.API_URL_FILE}/GeneralMeritList/tse/6_TSE Urban Prize Holders List.pdf`} 
            style={{color:'blue'}}
            target='_blank'>
      सर्वसाधारण गुणवत्ता यादी ६वी शहरी (2025-26)
              </a>
           
              </td>           
          </tr>
          <tr>
            <td>3</td>
            <td>           
            <a href={`${Config.API_URL_FILE}/GeneralMeritList/tse/6_TSE State Prize Holders List.pdf`} 
            style={{color:'blue'}}

            target='_blank'>

      राज्यस्तरीय प्रथम ३ क्रमांक विद्यार्थी ६वी (2025-26)
              </a>
           
              </td>           
          </tr>
        
      </tbody>
    </table>
        

        </div>

      </div>
    </section>
 

</main>
            </>
        )
    

}

export default TseGeneralMeritList